export const FETCH_SIGNUP_INIT = 'FETCH_SIGNUP_INIT';
export const FETCH_SIGNUP_SUCCESS = 'FETCH_SIGNUP_SUCCESS';
export const FETCH_SIGNUP_FAILURE = 'FETCH_SIGNUP_FAILURE';
